import Page from '../../classes/Page'
import { app } from '../../utils/store'

export default class Cookie extends Page{
    constructor(){
        super({
            id : 'cookie',
            element: '[data-app-page]',
            // elements: { key : 'nodeElementSelector' }
        })
    }

    create() {
        super.create()
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}